import React from 'react';
import { IconProps } from '.';

const SvgNumFourFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path
        fill={secondaryColor}
        d='M8.204 14.778h4.584v1.666h1.862v-1.666h1.198v-1.576H14.65V7.017h-2.461l-3.985 6.211v1.55Zm1.98-1.576v-.078l2.539-3.958h.09v4.036h-2.63Z'
      />
    </svg>
  );
};

export default SvgNumFourFill;
